<template>
  <div class="block">
    <BriefcaseIcon class="block__icon" /> Вы еще не выбрали активы
  </div>
</template>

<script setup>
  import BriefcaseIcon from '@/Groups/Briefcase/private/svg/BriefcaseIcon.vue';
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>